/**
 * Constants for feedback session view modes
 */

export const FEEDBACK_SESSION_VIEW_MODES = {
  EDIT: 'edit',
  VIEW: 'view',
  EDIT_EMPLOYEES: 'editEmployees',
  EDIT_REVIEWERS: 'editReviewers',
  REPORT: 'report'
};

/**
 * Get the title for a specific view mode
 * @param {string} viewMode - The view mode
 * @returns {string} The title for the view mode
 */
export const getViewModeTitle = (viewMode) => {
  switch (viewMode) {
    case FEEDBACK_SESSION_VIEW_MODES.EDIT:
      return 'Edit Feedback Session';
    case FEEDBACK_SESSION_VIEW_MODES.VIEW:
      return 'View Feedback Session';
    case FEEDBACK_SESSION_VIEW_MODES.EDIT_EMPLOYEES:
      return 'Edit Individuals and Reviewers';
    case FEEDBACK_SESSION_VIEW_MODES.EDIT_REVIEWERS:
      return 'Edit Reviewers';
    case FEEDBACK_SESSION_VIEW_MODES.REPORT:
      return 'Feedback Session Report';
    default:
      return 'Feedback Session';
  }
}; 